import React from "react";
import styled from "styled-components";
import LSRgH1HeadLine from "../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody02 from "../molecules/text/linSeedKr/Rg/lsRgBody02";
import { useNavigate } from "react-router-dom";

const SelectBox = ({
  style,
  subMenuStyle,
  isSmall,
  isMiddle,
  isOpen,
  wrapperHandler,
  selectedValue,
  placeholder,
  selectedValueSetterFunc,
  itemList,
  isLink,
  disabled,
}) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: "relative",
        width: isSmall ? 175 : isMiddle ? 312 : 628,
        ...style,
      }}
    >
      <SelectBoxWrapper
        isSmall={isSmall}
        onClick={() => {
          if (disabled) {
            return;
          }

          wrapperHandler(!isOpen);
        }}
        style={{
          cursor: "pointer",
        }}
      >
        {isSmall && (
          <LSRgBody02 style={{ color: "#A4A8B1" }}>
            {selectedValue ? selectedValue : placeholder}
          </LSRgBody02>
        )}

        {!isSmall && (
          <LSRgH1HeadLine style={{ color: "#A4A8B1" }}>
            {selectedValue ? selectedValue : placeholder}
          </LSRgH1HeadLine>
        )}
        <img
          className={isOpen ? "rotate" : "rotate-back"}
          style={{
            width: 20,
            height: 22,
          }}
          src="/assets/icons/selectbox_arrow.png"
          alt="펼치기"
        />
      </SelectBoxWrapper>
      {isOpen ? (
        <SubMenuWrapper
          isSmall={isSmall}
          isMiddle={isMiddle}
          className="custom-scrollbar"
          style={{
            ...subMenuStyle,
          }}
        >
          {itemList.map((item, index) => {
            return (
              <div
                key={index}
                isSmall={isSmall}
                style={{
                  width: "100%",
                  borderRadius: 3,
                  height: "41px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  selectedValueSetterFunc(item.title);

                  if (isLink) {
                    navigate(item.path);
                  }
                  wrapperHandler(false);
                }}
              >
                {isSmall && (
                  <LSRgBody02
                    style={{
                      color:
                        selectedValue === item.title ? "#262C31" : "#808991",
                    }}
                  >
                    {item.title}
                  </LSRgBody02>
                )}

                {!isSmall && (
                  <LSRgBody02
                    style={{
                      color:
                        selectedValue === item.title ? "#262C31" : "#808991",
                    }}
                  >
                    {item.title}
                  </LSRgBody02>
                )}
                {selectedValue === item.title ? (
                  <img
                    style={{
                      width: "18px",
                      height: "18px",
                    }}
                    src="/assets/icons/selectbox_checked.png"
                    alt=""
                  />
                ) : null}
              </div>
            );
          })}
        </SubMenuWrapper>
      ) : null}
    </div>
  );
};

export default SelectBox;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-radius: 12px;
  border: 1px solid #dbdde0;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: ${(props) =>
    props.isSmall ? "175px" : props.isMiddle ? "312px" : "628px"};
  min-height: 56px;
  max-height: 225px;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 66px;
  right: 0;
  padding: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 5;
`;
